import { privateAxios } from 'services/api/privateAxios';

export const deleteAddress = id =>
  privateAxios({
    method: 'delete',
    url: `/address/${id}`,
  });
